import BossMapContainer from "./BossMapContainer";

export default BossMapContainer;